import { zodResolver } from "@hookform/resolvers/zod"
import { useForm } from "react-hook-form"
import { useCreateTaskMutation, useDeleteTaskMutation } from "../../../api/tasks/mutation"; // Import the mutation
import { recommendedTaskSchema, TaskFormType } from "../schema"

interface UseTaskProps {
    id: string;
    taskType?: string;
    taskId?: string;
}

export const useTask = ({ id, taskType, taskId }: UseTaskProps) => {
    const form = useForm<TaskFormType>({
        resolver: zodResolver(recommendedTaskSchema),
        defaultValues: {
            type: taskType || "",
            instructions: "",
            cost: "",
            medications: []
        }
    })
    const createTaskMutation = useCreateTaskMutation();
    const deleteTaskMutation = useDeleteTaskMutation({ task_id: taskId || "", encounter_id: id });


    const onSubmitToApi = async (data: TaskFormType) => {
        const payload = {
            encounter_id: id,
            type: data.type || taskType || "", 
            program: 'weight_loss',
            cost: taskType === "appointment_followup" ? Number(data.cost?.replace('$', '')) : undefined,
            instructions: data.instructions,
            medications: data.medications?.map(med => {
                return { // Add 'return' here
                    name: med.medication_name || "",
                    dosage: med.dosage || "",
                    quantity: 0,
                    duration: med.duration || "",
                    cost: Number(med.cost?.replace('$', '')) || 0,
                    vitamin: med.vitamin?.name === undefined ? null : { name: med.vitamin?.name },
                    instructions: med.instructions || "",
                    refills: Number(med.refill) || 0
                }
            })
            
        };
        
        return createTaskMutation.mutateAsync(payload);
    }


    const onDeleteTask = () => {
        return deleteTaskMutation.mutateAsync();
    }

    return { 
        form, 
        onSubmitToApi,
        isSubmitting: createTaskMutation.isPending,
        isDeleting: deleteTaskMutation.isPending,
        onDeleteTask, 
    }
}
